import React, {
  memo,
  ReactNode,
  useState,
  ReactElement,
  useEffect,
  useRef,
} from "react";
import ActionButton from "./ActionButton";

type Props = {
  icon: ReactNode;
  children: ReactElement;
  className?: string;
  label?: string;
};

function DropdownButton(props: Props) {
  const [expanded, setexpanded] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const toggleMenu = (e: React.MouseEvent<HTMLElement>) => {
    setexpanded(!expanded);
    console.log("You clicked");
  };
  console.log(expanded);

  const collapse = (e: any) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setexpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", collapse);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", collapse);
    };
  });

  return (
    <div className="drop-down-button" onClick={toggleMenu} ref={ref}>
      <ActionButton
        icon={props.icon}
        label={props.label}
        className={props.className}
      />
      {expanded && <div className="drop-down-menu">{props.children}</div>}
    </div>
  );
}
function arePropsEqual(prevProps: any, nextProps: any) {
  return prevProps.label === nextProps.label;
}

export default memo(DropdownButton, arePropsEqual);
